import { UpdateProfileDto } from "@dune/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";
import { usersQueryKeys } from "../query-keys/users.query-keys";

const updateProfile = async (data: UpdateProfileDto) => {
	const { data: response } = await privateAxios.patch(
		"/users/me/profile",
		data,
	);
	return response;
};

export const useUpdateProfile = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: updateProfile,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: usersQueryKeys.profile(),
			});
			toast.success("Profil mis à jour avec succès");
		},
		onError: (
			error: Error & { response?: { data?: { message?: string } } },
		) => {
			const errorMessage =
				error?.response?.data?.message ||
				"Erreur lors de la mise à jour du profil";
			toast.error(errorMessage);
		},
	});
};

interface ChangePasswordDto {
	oldPassword: string;
	newPassword: string;
}

const changePassword = async (data: ChangePasswordDto) => {
	const { data: response } = await privateAxios.patch(
		"/users/me/password",
		data,
	);
	return response;
};

export const useChangePassword = () => {
	return useMutation({
		mutationFn: changePassword,
		onError: (
			error: Error & { response?: { data?: { message?: string } } },
		) => {
			console.error("Password change error:", error);
		},
	});
};
